import { withDevModalFilePath } from '../common';
import { DocumentDetailPage } from '../../pages/DocumentDetailPage';

interface DocumentDetailModalProps {
  open: boolean;
  documentId: string | null;
  onClose: () => void;
}

const { Modal } = withDevModalFilePath('client/src/components/document/DocumentDetailModal.tsx');

export function DocumentDetailModal({ open, documentId, onClose }: DocumentDetailModalProps) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width="90%"
      styles={{ body: { padding: 0 } }}
      destroyOnHidden
      centered
    >
      {documentId ? (
        <div style={{ padding: 24, maxHeight: '80vh', overflowY: 'auto' }}>
          <DocumentDetailPage documentId={documentId} mode="modal" onClose={onClose} />
        </div>
      ) : null}
    </Modal>
  );
}
